import React from 'react';
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { getApi } from '../services/apiServices';
import { toast } from 'react-toastify';
import './blogDetail.css';

function BlogDetail() {
  const location = useLocation();
  const { blog_id } = useParams();
  const navigate = useNavigate();
  const [blogData, setBlogData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  const fetchBlogDetails = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await getApi(`/api/blogs/${blog_id}`, { showSuccessToast: false });

      if (response?.status) {
        setBlogData(response.data?.blog || response.data);
      } else {
        setError(response?.message || 'Failed to fetch blog details');
        toast.error(response?.message || 'Failed to fetch blog details');
      }
    } catch (error) {
      console.error('Error fetching blog details:', error);
      setError('Failed to fetch blog details. Please try again.');
      toast.error('Failed to fetch blog details. Please try again.');
    } finally {
      setLoading(false);
    }
  };

 
  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      });
    } catch (error) {
      return dateString;
    }
  };

 
  const handleBackClick = () => {
    navigate('/blog');
  };

 
  useEffect(() => {
    if (blog_id) {
      fetchBlogDetails();
    }
  }, [blog_id]);

 
  if (loading) {
    return (
      <section className="recent-blog blog-detail">
        <div className="container">
          <div className="loader-overlay">
            <span className="loader"></span>
          </div>
        </div>
      </section>
    );
  }

  if (error || !blogData) {
    return (
      <section className="recent-blog blog-detail">
        <div className="container">
          <div className="text-center">
            <h3>Blog Not Found</h3>
            <p>{error || 'The blog you are looking for does not exist.'}</p>
            <button onClick={handleBackClick} className="btn btn-primary">
              Back to Blogs
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="recent-blog blog-detail">
        <div className="container">
          <div className="blog-navigation">
            <button onClick={handleBackClick} className="btn btn-link"  style={{ marginRight: '10px', color: '#FF7400' }}>
              ← Back to Blogs
            </button>
          </div>
          <h3 className="heading">{blogData.title}</h3>
          <div className="row">
            <div className="col-sm-12">
              <div className="blog-left">
                <div className="blog-left-img">
                  <img 
                    src={blogData.image_full_url || window.getPublicUrl('images/blog-left-img.jpg')} 
                    alt={blogData.title}
                    onError={(e) => {
                      e.target.src = window.getPublicUrl('images/blog-left-img.jpg');
                    }}
                  />
                </div>
                {/* <h4>{blogData.author} • {formatDate(blogData.created_at)}</h4> */}
               

                <div className='data-pera'>
                <p dangerouslySetInnerHTML={{ __html: blogData.description }} ></p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}

export default BlogDetail;
